"use client";

import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { cn } from "../../lib";
import { Particles } from "../shadcn/particles";
import type { MediaPlayerTheme } from "./media-player-theme";

export interface MediaPlayerAmbientBackdropProps {
	theme: MediaPlayerTheme;
	className?: string;
	children?: ReactNode;
}

export function MediaPlayerAmbientBackdrop({
	theme,
	className,
	children,
}: MediaPlayerAmbientBackdropProps) {
	const [reduceMotion, setReduceMotion] = useState(false);

	useEffect(() => {
		const media = window.matchMedia("(prefers-reduced-motion: reduce)");
		const update = () => setReduceMotion(media.matches);
		update();
		media.addEventListener("change", update);
		return () => media.removeEventListener("change", update);
	}, []);

	return (
		<div className={cn("relative overflow-hidden", className)}>
			<div
				className="pointer-events-none absolute inset-0 opacity-70"
				style={{
					background: `radial-gradient(ellipse 80% 60% at 50% 100%, ${theme.ambientGlowColor}33, transparent 70%)`,
				}}
				aria-hidden
			/>
			<Particles
				className="pointer-events-none absolute inset-0"
				quantity={reduceMotion ? 0 : 28}
				staticity={40}
				ease={70}
				color={theme.ambientParticleColor}
				size={0.6}
			/>
			{children}
		</div>
	);
}
